import { useEffect } from 'react'
import type { TDashboardPatientMedEvent } from '../dashboard.type'
import { useDashboard } from '../dashboard.provider'
import PatientMedEventDropdown from './dashboard-patient-medevent-dropdown.component'
import { useTranslation } from 'react-i18next'

export type TSortedGroupPatientMedEventItem = [string, TDashboardPatientMedEvent[]]

const PatientMedEventList = () => {
  const { i18n } = useTranslation()
  const locale = i18n.language
  const { dashboardPatientMedEventListToShow, dashboardPatientMedEventList, setSelectedPatientMedEvent } =
    useDashboard()

  const getGroupPatientMedEventByDate = (patientMedEventList: TDashboardPatientMedEvent[]) => {
    const sortedPatientMedEventList = [...patientMedEventList].sort((patientMedEvent1, patientMedEvent2) => {
      return new Date(patientMedEvent2.date).getTime() - new Date(patientMedEvent1.date).getTime()
    })
    return sortedPatientMedEventList.reduce((list, patientMedEvent) => {
      const patientMedEventDate = new Date(patientMedEvent.date)
      const groupLabel = patientMedEventDate.toLocaleDateString(locale)
      const existingIndex = list.findIndex(([gl]) => gl === groupLabel)
      if (existingIndex < 0) {
        list.push([groupLabel, [patientMedEvent]])
      } else {
        list[existingIndex]?.[1].push(patientMedEvent)
      }
      return list
    }, [] as TSortedGroupPatientMedEventItem[])
  }

  const sortedGroupPatientMedEventByDate: TSortedGroupPatientMedEventItem[] = getGroupPatientMedEventByDate(
    dashboardPatientMedEventListToShow,
  )

  // selected patient medevent default value
  useEffect(() => {
    if (dashboardPatientMedEventList) {
      const previousSelectedPatientMedEventId = Number(
        localStorage?.getItem('dashboardSelectedPatientMedEventId'),
      )
      const previousSelectedPatientMedEvent = dashboardPatientMedEventList?.find(
        (patientMedEvent) => patientMedEvent.id === previousSelectedPatientMedEventId,
      )
      if (previousSelectedPatientMedEvent && previousSelectedPatientMedEvent.status !== 'REVIEWED') {
        setSelectedPatientMedEvent(previousSelectedPatientMedEvent)
      } else {
        const firstPatientMedEventGroup =
          sortedGroupPatientMedEventByDate[0] && sortedGroupPatientMedEventByDate[0][1]
        if (!firstPatientMedEventGroup) return
        const firstPatientMedEvent = firstPatientMedEventGroup[0]
        if (!firstPatientMedEvent) return
        setSelectedPatientMedEvent(firstPatientMedEvent)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dashboardPatientMedEventList])

  return (
    <div className="c-w-40 lg:c-w-64 2xl:c-w-80 c-overflow-scroll c-flex c-flex-col c-rounded-tl-md c-rounded-bl-md c-shrink-0 c-max-h-[730px] c-min-h-full c-pb-12">
      {sortedGroupPatientMedEventByDate.map(([label, list]) => {
        return <PatientMedEventDropdown key={label} label={label} patientMedEventList={list} />
      })}
    </div>
  )
}
export default PatientMedEventList
